export async function queueCallProcessing(callId: string, action: 'transcribe' | 'extract'): Promise<void> {
  if (!callId.trim()) throw new Error('Call ID is required')
  const response = await fetch(`/api/calls/${encodeURIComponent(callId)}/${action}`, {
    method: 'POST',
    credentials: 'include',
  })
  const body: unknown = await response.json()
  if (!response.ok) {
    const message =
      typeof body === 'object' && body !== null && 'error' in body && typeof body.error === 'string'
        ? body.error
        : 'Could not queue call processing'
    throw new Error(message)
  }
  if (typeof body !== 'object' || body === null || !('queued' in body) || body.queued !== true) {
    throw new Error('Call processing was not queued')
  }
}
